import { render, staticRenderFns } from "./VirtualPub.vue?vue&type=template&id=2d47defa&scoped=true"
import script from "./VirtualPub.vue?vue&type=script&lang=ts"
export * from "./VirtualPub.vue?vue&type=script&lang=ts"
import style0 from "./VirtualPub.vue?vue&type=style&index=0&id=2d47defa&prod&lang=css"
import style1 from "./VirtualPub.vue?vue&type=style&index=1&id=2d47defa&prod&lang=scss"
import style2 from "./VirtualPub.vue?vue&type=style&index=2&id=2d47defa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47defa",
  null
  
)

export default component.exports